import { TableCellInputType } from "@components/data-table/types";

export const initialValues: Partial<Record<TableCellInputType, string>> = {
    [TableCellInputType.Text]: "",
    [TableCellInputType.Select]: "",
    [TableCellInputType.MultiLine]: "",
    [TableCellInputType.Boolean]: "",
};